// extracted by mini-css-extract-plugin
export default {"title":"back-link__title___T5xcT","icon":"back-link__icon___yKqeD","container":"back-link__container___oW9Uo","height0":"back-link__height0___R5a8j"};